module.exports = "<div ui-view ></div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/categories/categories.html
// module id = 380
// module chunks = 0